var _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConcentricCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 71,
    viewBox: "0 0 80 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.3488,
    cy: 0.578811,
    r: 60,
    transform: "rotate(-74.8187 70.3488 0.578811)",
    stroke: "#BCA2FF",
    strokeOpacity: 0.47,
    strokeWidth: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.4128,
    cy: -15.4134,
    r: 58,
    transform: "rotate(-74.8187 95.4128 -15.4134)",
    stroke: "#BCA2FF",
    strokeOpacity: 0.47,
    strokeWidth: 16
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentricCircles);
export default __webpack_public_path__ + "static/media/concentric_circles.ac6e8588fb9f25390e5210ea19d056e0.svg";
export { ForwardRef as ReactComponent };